import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import logo from "@/assets/logo.webp";
import { BUSINESS } from "@/lib/business";
import { PhoneButton } from "./PhoneButton";

const NAV: { to: string; label: string; hash?: string }[] = [
  { to: "/", hash: "services", label: "Services" },
  { to: "/areas-served", label: "Areas" },
  { to: "/emergency-plumbing-phoenix", label: "Emergency" },
  { to: "/reviews", label: "Reviews" },
  { to: "/blog", label: "Blog" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background/95 backdrop-blur">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3">
        <Link to="/" className="flex items-center gap-2" aria-label="Phoenix Plumbing Co. home">
          <img decoding="async" src={logo} alt="Phoenix Plumbing Co. logo" width={44} height={44} className="h-11 w-11 rounded" />
          <span className="hidden sm:block font-extrabold text-secondary leading-tight">
            Phoenix Plumbing
            <span className="block text-[10px] tracking-widest text-muted-foreground">CO.</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-6 text-sm font-semibold text-secondary">
          {NAV.map((n) => (
            <Link key={n.label} to={n.to} hash={n.hash} className="hover:text-primary transition-colors">
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <PhoneButton size="sm" />
        </div>

        <button
          aria-label="Toggle menu"
          className="lg:hidden p-2 text-secondary"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-border bg-background">
          <nav className="mx-auto flex max-w-7xl flex-col px-4 py-3 text-secondary font-semibold">
            {NAV.map((n) => (
              <Link key={n.label} to={n.to} hash={n.hash} onClick={() => setOpen(false)} className="py-2 border-b border-border last:border-0">
                {n.label}
              </Link>
            ))}
            <a href={BUSINESS.phoneHref} className="mt-3 inline-flex items-center justify-center rounded-md bg-primary text-primary-foreground py-3 font-extrabold">
              Call {BUSINESS.phone}
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}